import React from 'react';
import { Stack, Typography, useTheme, styled } from '@mui/material';

import { Container } from '@/components/layout';

const BackgroundStack = styled(Stack)`
  background-image: url(/images/press-center/hero-bg.png);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
`;

function Hero() {
  const theme = useTheme();

  return (
    <BackgroundStack
      sx={{
        height: { xs: '300px', md: '325px' },
        justifyContent: 'flex-end',
        paddingBottom: { xs: theme.spacing(10), md: theme.spacing(17.25) },
      }}
    >
      <Container>
        <Stack
          sx={{
            gap: { xs: theme.spacing(1), md: theme.spacing(2.5) },
          }}
        >
          <Typography
            fontSize="3.125rem !important"
            lineHeight="1.18 !important"
            variant="h1"
            color={theme.palette.common.white}
          >
            Press Center
          </Typography>

          <Typography
            variant="body2"
            color={theme.palette.common.white}
            sx={{
              fontSize: { xs: '1.125rem !important', md: '1.25rem !important' },
              lineHeight: { xs: '1.46 !important', md: '1.33 !important' },
            }}
          >
            Building a better future for your employees
          </Typography>
        </Stack>
      </Container>
    </BackgroundStack>
  );
}

export default Hero;

